<template>
    <v-dialog
        v-model="dialog"
        max-width="800"
        v-if="showUsageDialog==true"
        @click:outside="closePackageDialog()"
    >      
        <v-card>
            <Loading/>
            <v-toolbar
                dark                     
            >               
                <v-spacer></v-spacer>
                <v-toolbar-title>{{ $t('package') }}: {{ this.userInfo.planName }}</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-timeline align-top dense>
                <v-timeline-item small dark>
                    {{ $t('packageStartsAt') }} {{ this.userInfo.planStartDate }}
                </v-timeline-item>
                <v-timeline-item small color="cyan">
                    {{ $t('youAreAllowed') }} {{ $t('total') }} {{ this.userInfo.assessmentCount }} {{ $t('assessments') }}. {{ $t('youUsed') }} {{ showTotalQuizConsumed }} {{ $t('ofThose') }}.
                </v-timeline-item>
                <v-timeline-item small color="teal">
                    {{ $t('youCanCreate') }} {{ this.userInfo.questionPerAssessment }} {{$t('questionsForEach')}}.
                </v-timeline-item>
                <v-timeline-item small color="grey">
                    {{ $t('packageWillExpire') }} {{ this.userInfo.planExpiryDate }}
                </v-timeline-item>
            </v-timeline>
        </v-card>        
    </v-dialog>
</template>

<script>
import Loading from '../../components/common/Loading'

export default {
    name:'PackageUsageInfo',
    components:{
      Loading
    },
    data(){
        return{
            dialog:true,
            userInfo:{},
            totalQuizConsumed:''
        }
    },
    methods:{
        closePackageDialog(){
            this.$store.dispatch('dashboard/switchShowPackageUsage',false)
        },
        getUsageInfo(){
            this.$store.dispatch('dashboard/applyLoading')
            const obj={
                userId:this.userInfo.userId,
                paymentId:this.userInfo.paymentId,
            }
            this.$store.dispatch('dashboard/fetchPackageUsage',obj)
            .then((response)=>{
                this.$store.dispatch('dashboard/cancelLoading')
                if(response.status==200){
                   this.totalQuizConsumed=response.data.totalAssessmentConsumed
                }
            })
            .catch((err)=>{
                this.$store.dispatch('dashboard/cancelLoading')
                console.log(err)
                this.$router.push({name:'NoInternet'})
            })
        }
    },
    computed:{
        showUsageDialog(){
            return this.$store.getters['dashboard/showPackageUsage']
        },
        showTotalQuizConsumed(){
            return this.totalQuizConsumed
        },
    },
    watch:{
        showUsageDialog(){
            this.getUsageInfo()
        },
    },
    created(){
        this.userInfo=this.$store.getters['dashboard/userInfo']
        this.getUsageInfo()
    }
}
</script>
